import React from 'react'
import bannerImg from './banner-img.svg'

import {
  FluidBanner,
  FluidContentContainer,
  SmallImage,
  SmallCopy,
  Title,
  SmallContent,
} from './styles'
import { CONFIG } from '../../config'

const MarketingBanner = () => (
  <FluidBanner isMarketingBanner>
    <FluidContentContainer>
      <SmallImage src={bannerImg} alt="Sharing is caring" />
      <SmallCopy>
        <Title>
          Get an extra £{CONFIG.RAF_OFFER_AMOUNT} account credit for both you
          and your friend
        </Title>
        <SmallContent>
          Hurry, this offer ends soon.{' '}
          <a href="/terms" target="_blank" rel="noopener noreferrer">
            See full Ts and Cs
          </a>
        </SmallContent>
      </SmallCopy>
    </FluidContentContainer>
  </FluidBanner>
)

export default MarketingBanner
